import React, { FC } from 'react';
import ApplyForVettingDialogView from './ApplyForVettingDialogView';
import { useApplyForVettingDialogController } from '../../../controllers';
import { ApplyForVettingDialogProps } from '../../../types';

const ApplyForVettingDialog: FC<ApplyForVettingDialogProps> = props => {
  const viewModel = useApplyForVettingDialogController(props);
  return <ApplyForVettingDialogView {...viewModel} />;
};

export type { VettingPartner, VettingType } from '../../../types';
export default ApplyForVettingDialog;
